import Swiper, { Pagination } from 'swiper';

const SwiperContentHighlight = function () {
  
  // configure Swiper to use modules
  Swiper.use( Pagination );
  const els = document.querySelectorAll( '.swiper-content-highlight' );

  // loop through swiper sections and init Swiper
  if ( Object.keys(els).length ) {
    els.forEach( function( el ){
      const pagination = el.querySelector( '.swiper-pagination');
      const swiper = new Swiper( el , {
        direction: 'horizontal',
        spaceBetween: 20,
        slidesPerView: 'auto',
        centeredSlides: true,
        initialSlide: 0,
        loop: false,
        preventClicks: true,
        pagination: {
          el: pagination,
          clickable: true
        },
        breakpoints: {
          992: {
            slidesPerView: 'auto',
            spaceBetween: 0,
            pagination: false,
            centeredSlides: false
          }
        }
      })
    });
  }

}

export default SwiperContentHighlight;